"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var b=require("react");function a(){let[a,c]=b.useState(null);return{anchorEl:a,handleClose:()=>c(null),toggle:a=>c(a.currentTarget)}}exports.default=a
//# sourceMappingURL=useAnchorState.js.map
